import React from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";

function PropertyDetailsMap({ propertyDetailsData }) {  
  if (!propertyDetailsData) return null;

  const defaultMapCenter = { lat: propertyDetailsData.latitude, lng: propertyDetailsData.longitude };
  return (        
    <GoogleMap
      zoom={15}
      center={defaultMapCenter}
      mapContainerStyle={{ height: '100%', width: '100%' }}
      options={{
        cameraControl: false,
        zoomControl: true,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControlOptions: {
          style: window.google.maps.MapTypeControlStyle.DROPDOWN_MENU                                    
        },
      }}
    >
      <Marker position={defaultMapCenter} />
    </GoogleMap>
  )
}

export default PropertyDetailsMap;
  